import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";
import {Attribute} from "../../../components/ObjectAttribute";

const searchSalesOrdersRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/sales-orders',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/sales-orders' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const searchSalesOrdersResponse: Json = {
    title: 'RESPONSE',
    json: {
        title: 'response',
        json: {
            'totalCount': 20,
            'totalPages': 10,
            'pageNumber': 1,
            'pageSize': 2,
            'results': [
                {
                    'id': 83,
                    'number': '10088',
                    'customerName': 'Allan\'s Raceway',
                    'dateIssued': '2020-10-01T17:58:04.821-0600',
                    'dateScheduled': '2020-08-02T08:54:21.000-0600',
                    'status': 'Fulfilled',
                    'customerPo': 'ABCD1234'
                },
                {
                    'id': 85,
                    'number': '10089',
                    'customerName': 'Allan\'s Raceway',
                    'dateIssued': '2020-11-23T11:42:58.984-0700',
                    'dateScheduled': '2020-11-23T00:00:00.000-0700',
                    'status': 'In Progress',
                    'customerPo': ''
                }
            ]
        },
    },
};

const searchSalesOrdersQueryParameters: Attribute[] = [
    {
        name: 'pageNumber',
        type: 'integer',
        description: 'The current page of the results.',
        optional: true
    },
    {
        name: 'pageSize',
        type: 'integer',
        description: 'The number of returned results per page. (Default 100)',
        optional: true
    },
    {
        name: 'soNumber',
        type: 'string',
        description: 'The sales order number.',
        optional: true
    },
    {
        name: 'soType',
        type: 'string: \'Standard\' | \'Point of Sale\'',
        description: 'Indicates whether the order is a standard or point of sale sales order.',
        optional: true
    },
    {
        name: 'customerPoNumber',
        type: 'string',
        description: 'The customer purchase order number.',
        optional: true
    },
    {
        name: 'vendorPoNumber',
        type: 'string',
        description: 'The vendor purchase order number.',
        optional: true
    },
    {
        name: 'issuedFrom',
        type: 'date: \'yyyy-MM-dd\'',
        description: 'The start issued date cutoff for the search.',
        optional: true
    },
    {
        name: 'issuedTo',
        type: 'date: \'yyyy-MM-dd\'',
        description: 'The end issued date cutoff for the search.',
        optional: true
    },
    {
        name: 'fulfilledFrom',
        type: 'date: \'yyyy-MM-dd\'',
        description: 'The start fulfilled date cutoff for the search.',
        optional: true
    },
    {
        name: 'fulfilledTo',
        type: 'date: \'yyyy-MM-dd\'',
        description: 'The end fulfilled date cutoff for the search.',
        optional: true
    },
    {
        name: 'createdFrom',
        type: 'date: \'yyyy-MM-dd\'',
        description: 'The start creation date cutoff for the search.',
        optional: true
    },
    {
        name: 'createdTo',
        type: 'date: \'yyyy-MM-dd\'',
        description: 'The end creation date cutoff for the search.',
        optional: true
    },
    {
        name: 'modifiedFrom',
        type: 'date: \'yyyy-MM-dd\'',
        description: 'The start modification date cutoff for the search.',
        optional: true
    },
    {
        name: 'modifiedTo',
        type: 'date: \'yyyy-MM-dd\'',
        description: 'The end modification date cutoff for the search.',
        optional: true
    },
    {
        name: 'scheduledFrom',
        type: 'date: \'yyyy-MM-dd\'',
        description: 'The start scheduled date cutoff for the search.',
        optional: true
    },
    {
        name: 'scheduledTo',
        type: 'date: \'yyyy-MM-dd\'',
        description: 'The end scheduled date cutoff for the search.',
        optional: true
    },
    {
        name: 'customerName',
        type: 'string',
        description: 'The name of the customer.',
        optional: true
    },
    {
        name: 'productNumber',
        type: 'string',
        description: 'The product number.',
        optional: true
    },
    {
        name: 'productDescription',
        type: 'string',
        description: 'The description on the product.',
        optional: true
    },
    {
        name: 'productDetails',
        type: 'string',
        description: 'The details for the product.',
        optional: true
    },
    {
        name: 'status',
        type: 'string: \'All\' | \'All Open\' | \'For Calendar\' | \'Estimate\' | \'Issued\' | \'In Progress\' | \'Fulfilled\' | \'Closed Short\' | \'Voided\' | \'Cancelled\' | \'Expired\' | \'Historical\'',
        description: 'The order status.',
        optional: true
    },
    {
        name: 'locationGroupId',
        type: 'integer',
        description: 'The unique identifier for the location group on the order.',
        optional: true
    },
    {
        name: 'customerPartNumber',
        type: 'string',
        description: 'The number for the customer part.',
        optional: true
    },
    {
        name: 'salespersonId',
        type: 'integer',
        description: 'The unique identifier for the salesperson on the order.',
        optional: true
    },
    {
        name: 'billTo',
        type: 'string',
        description: 'The customer address on the order.',
        optional: true
    },
    {
        name: 'shipTo',
        type: 'string',
        description: 'The ship to address on the order.',
        optional: true
    },
    {
        name: 'accountNumber',
        type: 'string',
        description: 'The customer\'s account number.',
        optional: true
    },
    {
        name: 'carrierId',
        type: 'integer',
        description: 'The id of the carrier.',
        optional: true
    },
    {
        name: 'paymentStatus',
        type: 'string: \'Has Payment\' | \'Paid in Full\' | \'No Payment\' ',
        description: 'The payment status of the order.',
        optional: true
    },
    {
        name: 'totalPriceFrom',
        type: 'money',
        description: 'The start total price cutoff for the search.',
        optional: true
    },
    {
        name: 'totalPriceTo',
        type: 'money',
        description: 'The end total price cutoff for the search.',
        optional: true
    },
    {
        name: 'toBePrinted',
        type: 'boolean',
        description: 'Indicates whether the order is to be printed.',
        optional: true
    },
    {
        name: 'toBeEmailed',
        type: 'boolean',
        description: 'Indicates whether the order is to be emailed.',
        optional: true
    },
];

const searchSalesOrdersAttributes: Attribute[] = [
    {
        name: 'customFields',
        type: 'list',
        description: 'A list of the order\'s custom fields.',
        optional: true,
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identifier for the custom field.',

            },
            {
                name: 'value',
                type: 'string',
                description: 'The custom field\'s value.'
            },
        ]
    },
    {
        name: 'itemCustomFields',
        type: 'list',
        description: 'A list of the order\'s item\'s custom fields.',
        optional: true,
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identifier for the custom field.',

            },
            {
                name: 'value',
                type: 'string',
                description: 'The custom field\'s value.'
            },
        ]
    }
];

const data: RequestDefinitionData = {
    id: 'search-sales-orders',
    title: 'Search for sales orders',
    description: 'Searches for sales orders.',
    endpoint: {
        verb: 'GET',
        path: '/sales-orders',
        tooltip: 'Search sales orders',
    },
    attributes: searchSalesOrdersAttributes,
    requestObject: searchSalesOrdersRequest,
    responseObject: searchSalesOrdersResponse,
    queryParameters: searchSalesOrdersQueryParameters
};

export default data;
